import i18n from '@/lang/i18n';

export const DEFAULT_ITTENKO_GET_HOURS = 1;
export const DEFAULT_ITTENKO_GET_MINUTES = 0;

export const OPERATION_OFFICE_FORM_WEEKLY_AGGREGATION_LIST = [
  { label: '日', value: 'Sun' },
  { label: '月', value: 'Mon' },
  { label: '火', value: 'Tue' },
  { label: '水', value: 'Wed' },
  { label: '木', value: 'Thu' },
  { label: '金', value: 'Fri' },
  { label: '土', value: 'Sat' }
];

export const OPERATION_OFFICE_FORM_END_OF_MONTH_DATE_LIST = [
  { key: -2, label: i18n.global.t('pages.operationOffices.form.reportDeadLineDay.twoDayBefore') },
  { key: -1, label: i18n.global.t('pages.operationOffices.form.reportDeadLineDay.oneDayBefore') },
  { key: 0, label: i18n.global.t('pages.operationOffices.form.reportDeadLineDay.endOfTheMonth') },
];

export const DEFAULT_OVER_TIME_THRESHOLDS_DAILY = { hours: null, minutes: null }

export const DEFAULT_OVER_TIME_THRESHOLDS_MONTHLY = {
  1: { hours: null, minutes: null },
  2: { hours: null, minutes: null },
  3: { hours: null, minutes: null },
  4: { hours: null, minutes: null },
  5: { hours: null, minutes: null },
  6: { hours: null, minutes: null },
  7: { hours: null, minutes: null },
  8: { hours: null, minutes: null },
  9: { hours: null, minutes: null },
  10: { hours: null, minutes: null },
  11: { hours: null, minutes: null },
  12: { hours: null, minutes: null },
}

export const OPERATION_OFFICE_DEFAULT_FULL_COLOR_SETTING = {
  1: {
    alert_lv1_color: '#000000',
    alert_lv1_time: '',
    alert_lv2_color: '#000000',
    alert_lv2_time: '',
    alert_lv3_color: '#000000',
    alert_lv3_time: '',
  },
  2: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  3: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  4: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  5: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  6: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  7: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  8: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  9: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  10: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  11: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  },
  12: {
    alert_lv1_color: '#000000',
    alert_lv1_time: null,
    alert_lv2_color: '#000000',
    alert_lv2_time: null,
    alert_lv3_color: '#000000',
    alert_lv3_time: null,
  }
}

export const COOPERATION_LIST = [
  {
    key: null,
    label: ''
  },
  {
    key: 'ittenko_cooperation',
    label: i18n.global.t('pages.operationOffices.form.cooperationList.ittenko')
  },
];

export const CSV_DATE_FORMAT = [
  { key: 'Y/m/d H:i:s', label: 'YYYY/MM/DD HH:mm:ss' },
  { key: 'Y-m-d H:i:s', label: 'YYYY-MM-DD HH:mm:ss' },
  { key: 'Ymd H:i:s', label: 'YYYYMMDD HH:mm:ss' },
];

export const INITIAL_SENSOR_ALERT_NOTIFICATION_MAIL = {
  id: null,
  operation_office_id: null,
  email: null
}

export const SENSOR_ALERT_BATTERY_LEVEL = [
  {key: '10%', value: 10},
  {key: '20%', value: 20},
  {key: '30%', value: 30},
  {key: '40%', value: 40},
  {key: '50%', value: 50},
  {key: '60%', value: 60},
  {key: '70%', value: 70},
  {key: '80%', value: 80},
  {key: '90%', value: 90}
]

export const DEFAULT_SETTINGS_MONTHLY_REPORT = {
  color_setting_monthly: "0",
  color_setting: OPERATION_OFFICE_DEFAULT_FULL_COLOR_SETTING,
  bound_time_by_days: null,
  bound_time_by_hours: null,
  over_time_thresholds_type: "0",
  over_time_thresholds: {
    daily: DEFAULT_OVER_TIME_THRESHOLDS_DAILY,
    monthly: DEFAULT_OVER_TIME_THRESHOLDS_MONTHLY
  },
  over_time_working_hour_thresholds: {},
  csv_date_format: CSV_DATE_FORMAT[0],
  report_deadline_day: OPERATION_OFFICE_FORM_END_OF_MONTH_DATE_LIST[2],
  cooperation: COOPERATION_LIST[0]
}

export const TRACKING_SERVICE_DOCOMAP = 'docomap';
export const TRACKING_SERVICE_OCTLINK = 'octlink';
export const SELECTABLE_TRACKING_SERVICE = [ TRACKING_SERVICE_OCTLINK, TRACKING_SERVICE_DOCOMAP ];

export const VIEW_THRESHOLD = [
  { label: i18n.global.t('pages.operationOffices.form.viewThreshold.display'), value: '1' },
  { label: i18n.global.t('pages.operationOffices.form.viewThreshold.hidden'), value: '0' },
];

export const IS_DISPLAY_ALLOCATED = [
  { label: i18n.global.t('pages.operationOffices.form.viewThreshold.display'), value: true },
  { label: i18n.global.t('pages.operationOffices.form.viewThreshold.hidden'), value: false },
];

export const SELECTABLE_WORK_EVENT_TYPE = [
  {
    value: 'loading',
    name: i18n.global.t('pages.operationOffices.form.allocatedWork.loading')
  },
  {
    value: 'unloading',
    name: i18n.global.t('pages.operationOffices.form.allocatedWork.unloading')
  },
  {
    value: 'shipping',
    name: i18n.global.t('pages.operationOffices.form.allocatedWork.shipping')
  },
  {
    value: 'incidental_work',
    name: i18n.global.t('pages.operationOffices.form.allocatedWork.incidentalWork')
  },
  {
    value: 'refueling',
    name: i18n.global.t('pages.operationOffices.form.allocatedWork.refueling')
  },
  {
    value: 'wait',
    name: i18n.global.t('pages.operationOffices.form.allocatedWork.wait')
  },
  {
    value: 'break',
    name: i18n.global.t('pages.operationOffices.form.allocatedWork.break')
  },
]
